module.exports = __webpack_public_path__ + "media/images/icons/location-a80249202492f915c2c9f744d168925e.svg";